require('../core/grpn-lazyload');

module.exports = Groupon.Utils.lazyLoadImages = function(options, triggerClass) {
  var $el;
  if (triggerClass == null) {
    triggerClass = '.lazy-load';
  }
  if (($el = $(triggerClass)).length) {
    $el.lazyload(options);
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvc3JjL2Zyb250ZW5kL2hlbHBlci9sYXp5TG9hZEltYWdlcy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvYXJpY2h0ZXIvcmVwb3NpdG9yaWVzL3Nscy9zcmMvZnJvbnRlbmQvaGVscGVyL2xhenlMb2FkSW1hZ2VzLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFBLENBQVEsdUJBQVI7O0FBRUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsT0FBTyxDQUFDLEtBQUssQ0FBQyxjQUFkLEdBQStCLFNBQUMsT0FBRCxFQUFVLFlBQVY7QUFDOUMsTUFBQTs7SUFEd0QsZUFBZTs7RUFDdkUsSUFBeUIsQ0FBQyxHQUFBLEdBQU0sQ0FBQSxDQUFFLFlBQUYsQ0FBUCxDQUF1QixDQUFDLE1BQWpEO0lBQUEsR0FBRyxDQUFDLFFBQUosQ0FBYSxPQUFiLEVBQUE7O0FBRDhDIn0=
